import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { IProduct, IVariant } from 'base/interfaces/product';
import { useStore, observer } from 'base/store';

export type PriceDirectionType = 'horizontal' | 'break-horizontal' | 'vertical';

type ProductPriceProps = Globals.BaseProps & {
    product: IProduct | IVariant;
    showDelPrice?: boolean;
    direction?: PriceDirectionType;
};

const ProductPrice: React.FC<ProductPriceProps> = props => {
    const {
        product: {
            shopPriceExchangeDisplay,
            dealPriceExchangeDisplay,
            dealerShopPriceExchangeDisplay = '',
        },
        showDelPrice = true,
        className,
        style,
    } = props;
    let { direction = 'break-horizontal' } = props;
    const { userStore } = useStore();

    const isDeal = dealPriceExchangeDisplay && showDelPrice;
    const isDealer = userStore.isDealer();
    const showDealerPrice = isDealer && dealerShopPriceExchangeDisplay !== '';
    if (!isDealer && direction == 'break-horizontal') {
        direction = 'horizontal';
    }

    return (
        <div
            style={style}
            className={cn(
                className,
                styles.prices,
                styles[direction],
                direction,
                'prices',
                { 'prices-deal': isDeal },
            )}
        >
            {isDeal ? (
                <>
                    <strong tabIndex={0} className="shop-price deal-price">{dealPriceExchangeDisplay}</strong>

                    {showDealerPrice && (
                        <span className="price del-price">{dealerShopPriceExchangeDisplay}</span>
                    )}

                    <del className="price del-price">
                        {shopPriceExchangeDisplay}
                    </del>
                </>
            ) : (
                <>
                    <strong tabIndex={0} className={cn('shop-price', { 'deal-price': dealPriceExchangeDisplay })}>
                        {dealPriceExchangeDisplay || shopPriceExchangeDisplay}
                    </strong>

                    {showDealerPrice && (
                        <span className="price del-price">{dealerShopPriceExchangeDisplay}</span>
                    )}
                </>
            )}
        </div>
    )
};

export default observer(ProductPrice);